import { memo } from 'react'

import { SendIcon } from 'assets/icons/send'
import { ZaiIcon } from 'assets/icons/zai'
import { withTolgee } from 'lib/tolgee'

import { translations } from './zai-hero.i18n'
import type { IZaiHeroFormProps } from './zai-hero.types'

const Component = withTolgee<IZaiHeroFormProps>(({ onSubmit, t }) => (
  <form
    className="zai-hero-form"
    onSubmit={event => {
      event.preventDefault()

      onSubmit(event)
    }}
  >
    <div className="zai-hero-form-icon">
      <ZaiIcon color="#6224C6" width="100%" height="100%" />
    </div>
    <input
      id="pre-prompt-text"
      name="pre-prompt-text"
      type="text"
      placeholder={t(translations.inputPlaceholder)}
      className="zai-hero-form-input"
    />
    <button type="submit" className="zai-hero-form-button-send">
      <SendIcon color="#fafafa" width="14px" height="14px" />
    </button>
  </form>
))

export const ZaiHeroForm = memo(Component)
